import { CrmUser } from "./user.model";

export class ComplaintStatus {
    constructor(
        public id: number = 0,
        public name: string = null
    ) { }
}